import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchMenuPreview } from './menuPreviewApi';
import type { MenuCategory } from '../MenuCategory/menuCategorySlice';

interface MenuPreviewState {
  categories: MenuCategory[];
  loading: boolean;
  error: string | null;
}

const initialState: MenuPreviewState = {
  categories: [],
  loading: false,
  error: null,
};

const menuPreviewSlice = createSlice({
  name: 'menuPreview',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenuPreview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMenuPreview.fulfilled, (state, action: PayloadAction<MenuCategory[]>) => {
        state.categories = action.payload;
        state.loading = false;
      })
      .addCase(fetchMenuPreview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default menuPreviewSlice.reducer;
